'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/shared/components/ui/button';
import { RefreshCcw, Home, Music } from 'lucide-react';

export default function SongsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Songs list error:', error);
  }, [error]);

  return (
    <main className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-md mx-auto text-center">
          <div className="mb-8">
            <Music className="h-16 w-16 mx-auto text-muted-foreground mb-4" />
            <h1 className="text-2xl font-semibold mb-2">เกิดข้อผิดพลาด</h1>
            <p className="text-muted-foreground">
              ไม่สามารถโหลดรายการเพลงได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง
            </p>
            {error.digest && (
              <p className="text-sm text-muted-foreground mt-2">
                Error ID: {error.digest}
              </p>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={reset} className="gap-2">
              <RefreshCcw className="h-4 w-4" />
              ลองใหม่อีกครั้ง
            </Button>
            <Button
              variant="ghost"
              nativeButton={false}
              render={
                <Link href="/" className="gap-2">
                  <Home className="h-4 w-4" />
                  หน้าแรก
                </Link>
              }
            />
          </div>
        </div>
      </div>
    </main>
  );
}
